<template>
  <div class="job_opportunities jpl_shortcode">
    <div class="filters">
      <select v-model="location" @change="fetchJobs()">
        <option
          v-for="option in options.locations"
          v-bind:value="option.value"
          :key="option.value"
        >
          {{ option.text }}
        </option>
      </select>
      <select v-model="team" @change="fetchJobs()">
        <option
          v-for="option in options.team"
          v-bind:value="option.value"
          :key="option.value"
        >
          {{ option.text }}
        </option>
      </select>
      <select v-model="commitment" @change="fetchJobs()">
        <option
          v-for="option in options.commitment"
          v-bind:value="option.value"
          :key="option.value"
        >
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="loading" v-if="this.loading">
      <img :src="loading_image_url" />
    </div>
    <div
      v-else
      class="job_opportunities_container"
      v-for="job in jobs"
      :key="job.id"
    >
      <JobItem :job="job" :job_url="job_url" />
    </div>
    <div class="no-results" v-if="!this.jobs.length && this.loading == false">
      <span v-if="urlParams != '?'">
        There are no jobs matching your search criteria at the moment.
      </span>
      <span v-else>
        There are no active jobs at the moment.
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import JobItem from "./JobItem.vue";

export default {
  name: "Jobs",
  props: ["wpLever"],
  components: {
    JobItem,
  },
  data() {
    return {
      loading: null,
      jobs: [],
      job_url: "",
      location: "",
      team: "",
      commitment: "",
      options: {
        locations: [
          {
            value: "",
            text: "Location",
          },
          {
            value: "Chicago",
            text: "Chicago",
          },
          {
            value: "Baltimore",
            text: "Baltimore",
          },
          {
            value: "Philadelphia",
            text: "Philadelphia",
          },
          {
            value: "St. Louis",
            text: "St. Louis",
          },
        ],
        team: [
          {
            value: "",
            text: "Category",
          },
          {
            value: "Accounting",
            text: "Accounting",
          },
          {
            value: "Administration",
            text: "Administration",
          },
          {
            value: "Client Analyst",
            text: "Client Analyst",
          },
          {
            value: "Consultant",
            text: "Consultant",
          },
          {
            value: "Human Resources",
            text: "Human Resources",
          },
          {
            value: "Information Technology",
            text: "Information Technology",
          },
          {
            value: "Marketing",
            text: "Marketing",
          },
          {
            value: "OCIO",
            text: "OCIO",
          },
          {
            value: "Performance Analyst",
            text: "Performance Analyst",
          },
          {
            value: "Research",
            text: "Research",
          },
        ],
        commitment: [
          {
            value: "",
            text: "Job Type",
          },
          {
            value: "Full-Time",
            text: "Full-time",
          },
          {
            value: "Part-Time",
            text: "Part-time",
          },
          {
            value: "Intern",
            text: "Intern",
          },
        ],
      },
    };
  },
  computed: {
    // a computed getter
    urlParams: function() {
      let urlParams = [];
      if (this.location != "") urlParams.push("location=" + this.location);
      if (this.team != "") urlParams.push("team=" + this.team);
      if (this.commitment != "")
        urlParams.push("commitment=" + this.commitment);

      return "?" + urlParams.join("&");
    },
  },
  methods: {
    fetchJobs() {
      if (this.loading === false || this.loading === null) {
        this.loading = true;
        axios
          // .post(wpLever.ajaxurl, params) // eslint-disable-line
          .get(
            "https://jobs.lever.co/v0/postings/" +
              wpLever.params.site_url +
              this.urlParams
          ) // eslint-disable-line
          .then((response) => {
            this.jobs = response.data;
            this.loading = false;
          })
          .catch((error) => {
            if (error.response) {
              this.loading = false;
              this.jobs = [];
            }
          });
      }
    },
  },
  created() {
    this.job_url = wpLever.joburl; // eslint-disable-line
    this.loading_image_url = wpLever.loading_image_url; // eslint-disable-line
    this.fetchJobs();
  },
};
</script>
